<template>
  <section class="content" style="background-color: #EBECF1">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-info">
          <div class="box-header">
            <h3 class="fuente box-title p-t-10">MANTENIMIENTO DE OPERACIONES</h3>
          </div>
          <div class="box-body">
            <form role="form">
              <div class="row">
                <div class="box-body">
                  <div class="fuente col-xs-12">
                    <strong>APLICACIÓN</strong>
                  </div>
                  <div class="col-xs-6">
                    <!----
                    <select class="fuente form-control m-t-10 m-b-10 custom-cursor" v-on:change="limpiar()"
                      v-model="idAppFil">
                      <option v-for="app in apps" v-bind:value="app.idApp">
                        {{ app.descripcion }}
                      </option>
                    </select>
                    ---->
                    <v-select v-model="selectedIdApp" :options="filteredApps" :filterable="true" label="nombreApp"
                      @input="selectApp" class="fuente form-control m-t-10 m-b-10 combobox-personalizado4"
                      placeholder="SELECCIONAR APLICACIÓN"
                      style="width: 100%; padding: 0px; border-style: hidden;">
                      <template v-slot:no-options="{ search }">
                        Lo siento, no hay aplicaciones que coincidan con "{{ search }}".
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="box-footer" style="padding-left:15px;">
                <button type="button" class="fuente btn btn-primary fs-13" data-toggle="modal" @click="limpiar()"
                  data-target="#modalNuevo">Nuevo Registro</button>
              </div>
              <div class="row">
                <div class="fuente col-xs-12 table-responsive">
                  <div class="box-body">
                    <table aria-describedby="tablaDetalle_info" role="grid" id="tablaDetalle"
                      class="fuente fs-12 table table-bordered table-striped dataTable">
                      <thead>
                        <tr role="row">
                          <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting_asc">ITEM</th>
                          <th aria-label="DESCRIPCIÓN" aria-controls="tablaDetalle" tabindex="0" class="sorting_asc">
                            DESCRIPCIÓN</th>
                          <th aria-label="PRINCIPAL" aria-controls="tablaDetalle" tabindex="0" class="sorting">PRINCIPAL
                          </th>
                          <th aria-label="OPE SUP" aria-controls="tablaDetalle" tabindex="0" class="sorting">OPE SUP</th>
                          <th aria-label="OPE SUP" aria-controls="tablaDetalle" tabindex="0" class="sorting">SECCIÓN</th>
                          <th aria-label="ENLACE" aria-controls="tablaDetalle" tabindex="0" class="sorting">ENLACE</th>
                          <th aria-label="ROL" aria-controls="tablaDetalle" tabindex="0" class="sorting">ROL</th>
                          <th aria-label="ICONO" aria-controls="tablaDetalle" tabindex="0" class="sorting">ÍCONO</th>
                          <th aria-label="TITULO ADIC" aria-controls="tablaDetalle" tabindex="0" class="sorting">TÍTULO
                            ADICIONAL</th>
                          <th aria-label="ICONO ADIC" aria-controls="tablaDetalle" tabindex="0" class="sorting">ÍCONO
                            ADICIONAL</th>
                          <th aria-label="DESCRIPCION ADIC" aria-controls="tablaDetalle" tabindex="0" class="sorting">
                            DESCRIPCIÓN ADICIONAL</th>
                          <th aria-label="MODIFICAR" aria-controls="tablaDetalle" tabindex="0" class="sorting">MODIFICAR
                          </th>
                          <th aria-label="ANULAR" aria-controls="tablaDetalle" tabindex="0" class="sorting">ANULAR</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="even" role="row" v-for="item in opes">
                          <td class="sorting_1">{{ item.cont }}</td>
                          <td>{{ item.descripcion }}</td>
                          <td>{{ item.principal }}</td>
                          <td>{{ item.opeSup }}</td>
                          <td>{{ item.flagSeccion }}</td>
                          <td>{{ item.enlaceWeb }}</td>
                          <td>{{ item.nomRol }}</td>
                          <td>{{ item.icono }}</td>
                          <td>{{ item.titulo_adic }}</td>
                          <td>{{ item.icono_adic }}</td>
                          <td>{{ item.descripcion_adic }}</td>
                          <td><span style="cursor:pointer" class="badge bg-blue" data-toggle="modal" @click="ver(item)"
                              data-target="#modalNuevo">O</span></td>
                          <td><span style="cursor:pointer" class="badge bg-red" data-toggle="modal"
                              @click="verAnular(item)" data-target="#modalAnular">X</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="fuente col-md-12" style="color: red;">
                    {{ error.desError }}
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalNuevo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">{{ texto }}</h4>
                      </div>
                      <div class="fuente modal-body fs-12">
                        Aplicación:<br />
                        <!----
                        <select class="form-control m-t-10 m-b-10 custom-cursor"
                          v-on:change="cargaOpeSup(ope.idApp); cargarRoles(ope.idApp)" v-model="ope.idApp">
                          <option v-for="app in apps" v-bind:value="app.idApp">
                            {{ app.descripcion }}
                          </option>
                        </select>
                        ---->                        
                        <v-select v-model="selectedIdApp" :options="filteredApps" :filterable="true" label="nombreApp"
                          @input="selectApp" class="fuente form-control m-t-10 m-b-10 combobox-personalizado5"
                          placeholder="Seleccionar Aplicación"
                          style="width: 100%; max-width: 550px; padding: 0px; border-style: hidden;">
                          <template v-slot:no-options="{ search }">
                            Lo siento, no hay aplicaciones que coincidan con "{{ search }}".
                          </template>
                        </v-select>

                        Descripción:<br />
                        <input type="text" class="form-control m-t-10 m-b-10" v-model="ope.descripcion" />
                        <div class="row m-b-10">
                          <div class="col-md-6">
                            Operación Superior :<br />
                            <div class="position-relative" style="display: flex; align-items: center;">
                              <select class="form-control m-t-10 m-b-10 custom-cursor" v-model="ope.idOpeSup"
                                :disabled="cbOpes.length === 0 || ope.flagPrincipal == '1'">
                                <template v-if="cbOpes.length > 0 && ope.flagSeccion=='I'">
                                  <option disabled value="0" selected hidden>Seleccionar</option>
                                  <option v-for="itemOpe in cbOpes" v-bind:value="itemOpe.idOperacion">
                                    {{ itemOpe.descripcion }}
                                  </option>
                                </template>
                                <template v-else-if="opes.length > 0 && cbOpes.length > 0 && (ope.flagSeccion=='D' || ope.flagSeccion == 'S')">
                                  <option disabled value="0" selected hidden>Seleccionar</option>
                                  <option v-for="itemOpe in opes" v-bind:value="itemOpe.idOperacion">
                                    {{ itemOpe.descripcion }}
                                  </option>
                                </template>
                                <template v-else>
                                  <option disabled value="0" selected hidden>No hay opciones
                                  </option>
                                </template>
                              </select>
                              <!---- Botón X para deshacer selección de OpeSup en el combobox, solo visible en Agregar Nuevo --->
                              <button v-if="ope.idOpeSup !== '0' && ope.idOperacion === '0'" @click="resetSelection2"
                                class="clear-button" title="Deshacer selección de Operación Superior actual">
                                <!--- <span style="font-weight: bold; font-size: 12px;">X</span>-->
                                <i class="fa fa-times" style="font-size: 14px;"></i>
                              </button>
                            </div>
                          </div>
                          <div class="col-md-6">
                            Rol :<br />
                            <div class="position-relative" style="display: flex; align-items: center;">
                              <!------ combobox para obtener los roles   ---------->
                              <select class="form-control m-t-10 m-b-10 custom-cursor" v-model="ope.idRol"
                                :disabled="rols.length === 0">
                                <template v-if="rols.length > 0">
                                  <option disabled value="0" selected hidden>Seleccionar Rol</option>
                                  <option v-for="itemOpro in rols" v-bind:value="itemOpro.idRol">
                                    {{ itemOpro.descripcion }}
                                  </option>
                                </template>
                                <template v-else>
                                  <option disabled value="0" selected hidden>No hay roles disponibles
                                  </option>
                                </template>
                              </select>
                              <!---- Botón X para deshacer selección del Rol en el combobox, solo visible en Agregar Nuevo --->
                              <button v-if="ope.idRol !== '0' && ope.idOperacion === '0'" @click="resetSelection"
                                class="clear-button" title="Deshacer selección de Rol actual">
                                <!---<span style="font-weight: bold; font-size: 12px;">X</span> --->
                                <i class="fa fa-times" style="font-size: 14px;"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="row m-b-10">
                          <div class="col-md-6">
                            Es Principal:<br>
                            <div class="m-t-10 m-l-10">
                              <input type="checkbox" v-model="ope.flagPrincipal" true-value="1" false-value="0" :disabled="this.ope.idOperacion !== '0' && this.ope.idOpeSup !== 0">
                            </div>
                          </div>
                          <div class="col-md-6">
                            Sección:
                            <select class="form-control m-t-10" v-model="ope.flagSeccion">
                              <option value="I">I</option>
                              <option value="D">D</option>
                              <option value="S">S</option>
                            </select>
                          </div>
                        </div>
                        Enlace Web:<br />
                        <input type="text" class="form-control m-t-10" v-model="ope.enlaceWeb" />
                        <br />
                        <div class="row m-b-10">
                          <div class="col-md-6">
                            Ícono:<br>
                            <input type="text" class="form-control m-t-10 m-b-10" v-model="ope.icono" />
                          </div>
                          <div class="col-md-6">
                            Ícono Adicional:
                            <input type="text" class="form-control m-t-10 m-b-10" v-model="ope.icono_adic" />
                          </div>
                        </div>
                        Título Adicional:<br />
                        <input type="text" class="form-control m-t-10" v-model="ope.titulo_adic" />
                        <br />
                        Descripción Adicional:<br />
                        <input type="text" class="form-control m-t-10" v-model="ope.descripcion_adic" />
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-primary fs-13" @click="merge()" data-dismiss="modal"
                          :disabled="!ope.descripcion"
                          :title="!ope.descripcion ? 'Para guardar, es necesario rellenar el campo Descripción' : ''">Guardar
                          Cambios</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalAnular" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">¿DESEAS ANULAR LA OPERACIÓN?</h4>
                      </div>
                      <div class="fuente modal-body">
                        Se anulará la operación {{ ope.descripcion }} <br />
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-danger fs-13" @click="merge()"
                          data-dismiss="modal">Anular Operación</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import 'datatables.net'
import 'datatables.net-bs'
import axios from 'axios'
import $ from 'jquery'
import { apiURL, apiLOGIN } from '@/store/state' //llamando al apiURL del store
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
//import App from '../App.vue';
import App from '@/components/App.vue';
import moment from 'moment';

export default {
  name: 'Tables',
  data() {
    return {
      vidApp: '0',
      texto: '',
      apps: [],
      idAppFil: '1',
      error: {
        desError: ''
      },
      opes: [],
      cbOpes: [],
      ope: {
        idOperacion: '0',
        descripcion: '',
        idApp: '0',
        flagPrincipal: '0',
        enlaceWeb: '',
        idOpeSup: '0',
        idRol: '0', //
        idOpeXRol: '0', //
        flagSeccion: 'I',
        icono: '',
        titulo_adic: '',
        icono_adic: '',
        descripcion_adic: '',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      rols: [],
      opesByOpeSup: [],
      opexrolArray2: [],
      tiempoActual: null,
      tiempoTokenExp: null,
      /// del v-select
      searchText: '',
      selectedIdApp: null,
      appSeleccionada: {},
    }
  },
  components: {
    vSelect,
  },
  mounted() {
    //this.tiempoActual = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });    
    //this.tiempoTokenExp = localStorage.getItem('TokenExpirationTime')
    this.tiempoActual = moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a");
    this.tiempoTokenExp = moment(localStorage.getItem('TokenExpirationTime'), "D/M/YYYY, h:mm:ss a");

    if (!this.$session.exists('token')) {
      App.methods.logout.call(this);
      return;
    }

    if (this.tiempoActual < this.tiempoTokenExp) {
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      // Realizar la validación con la API
      axios.get(`${apiLOGIN}/operaciones/app/GESU/operaciones`)
        .then(response => {
          if (response.data.codError === 1 || response.data.desError === 'ok') {
            // La validación es exitosa, continuar con la carga de datos
            this.carga();
          } else {
            // La validación no es exitosa, redirigir a la vista anterior
            //console.log("Usuario No Autorizado")
            //this.$router.go(-1);
            this.alertaError();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            // Manejar el caso de error de autorización
            //this.$router.go(-1);
            this.alertaError401();
          } else if (error.response && error.response.status === 403) {
            //this.$router.go(-1);
            this.alertaError();
          } else if (error.response && error.response.status === 500) {
            //this.$router.go(-1); 
            this.alertaError500();
          } else {
            //this.$router.go(-1);
            this.alertaError401();
          }
        });
    } else {
      this.alertaError401();
    }
  },

  methods: {
    carga() {
      // Destruir la instancia DataTable si ya existe
      const dataTableInstance = $('#tablaDetalle').DataTable();
      if (dataTableInstance) {
        dataTableInstance.destroy();
      }

      ////Carga las Operaciones según la Aplicación
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/*/' + this.idAppFil + '/0'
        `${apiURL}/operaciones/*/` + this.idAppFil + '/0'
      ).then(response => {
        this.opes = response.data

        this.$nextTick(() => {
          $('#tablaDetalle').DataTable({
            stateSave: true, // Guarda el estado y la paginación de la tabla
            'stateSaveParams': function (settings, data) {
              data.length = 25; // Establece la longitud de la página
            },
            pageLength: 25,
            'oLanguage': {
              'sSearch': 'Buscar',
              'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
              'sEmptyTable': 'Sin Data',
              'ZeroRecords': 'No se encontraron coincidencias',
              'sInfoFiltered': '(Filtrado de un total de _MAX_ registros)',
              'sLengthMenu': '_MENU_ Registros por pagina',
              'oPaginate': {
                'sPrevious': 'Anterior',
                'sNext': 'Siguiente'
              }
            }
          })
        })
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      //// Carga las Aplicaciones al combobox
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/aplicaciones/*'
        `${apiURL}/aplicaciones/*`
      ).then(response => {
        this.apps = response.data
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },

    merge: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        axios.post(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/ope/add',
          `${apiURL}/operaciones/ope/add`,
          {
            'idOperacion': this.ope.idOperacion,
            'descripcion': this.ope.descripcion,
            'idApp': this.ope.idApp,
            'flagPrincipal': this.ope.flagPrincipal,
            'enlaceWeb': this.ope.enlaceWeb,
            'idOpeSup': this.ope.idOpeSup,
            'flagSeccion': this.ope.flagSeccion,
            'icono': this.ope.icono,
            'titulo_adic': this.ope.titulo_adic,
            'icono_adic': this.ope.icono_adic,
            'descripcion_adic': this.ope.descripcion_adic,
            'flagActivo': this.ope.flagActivo,
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.error = response.data

          //// Solo al Modificar o Anular Operación (buscar las operaciones donde es su OpeSup y a cada una modificarlas o anularlas)        
          if ((this.ope.flagPrincipal == 0 && this.ope.idOperacion !== '0' && this.ope.flagActivo !== '0') || (this.ope.flagPrincipal !== 0 && this.ope.flagActivo === '0')) {
            /////Cargamos todas las operaciones y filtramos solo las que su idOpeSup sean igual al this.ope.idOperacion

            axios.get(
              //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/*/' + this.idAppFil + '/0'
              `${apiURL}/operaciones/*/` + this.idAppFil + '/0'
            ).then(response => {
              this.opesByOpeSup = response.data.filter(item => item.idOpeSup === this.ope.idOperacion);
              //console.log('opesByOpeSup filtradas por idOpeSup:', this.opesByOpeSup);

              if (this.opesByOpeSup.length !== 0) {
                ////Hacemos un forEach para realizar el cambio en idOpeSup a cada operación obtenida
                this.opesByOpeSup.forEach((array2) => {
                  ///////Y le cambiamos el ideOpeSup a '0'
                  axios.post(
                    //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/ope/add',
                    `${apiURL}/operaciones/ope/add`,
                    {
                      'idOperacion': array2.idOperacion,
                      'descripcion': array2.descripcion,
                      'idApp': array2.idApp,
                      'flagPrincipal': array2.flagPrincipal,
                      'enlaceWeb': array2.enlaceWeb,
                      'idOpeSup': this.ope.idOpeSup,
                      'flagSeccion': array2.flagSeccion,
                      'icono': array2.icono,
                      'titulo_adic': array2.titulo_adic,
                      'icono_adic': array2.icono_adic,
                      'descripcion_adic': array2.descripcion_adic,
                      'flagActivo': this.ope.flagActivo,
                      'usuario': this.$session.get('user')
                    }
                  ).then(response => {
                    this.error5 = response.data

                    ////Después de Anular Operación dependientes de OpeSup, también anular sus operacionxrol en caso el idRol del array2 no sea '0'
                    if (array2.idRol !== 0) {
                      axios.get(
                        `${apiURL}/operaciones/opexrolByOpe/` + array2.idOperacion
                      ).then(response => {
                        this.opexrolArray2 = response.data
                        //console.log('---opexrolArray2', this.opexrolArray2);

                        this.opexrolArray2.forEach((array3) => {
                          axios.post(
                            //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/opeByRol/add',
                            `${apiURL}/operaciones/opeByRol/add`,
                            {
                              'idOpeXRol': array3.idOpeXRol,
                              'idRol': array3.idRol,
                              'idOperacion': array3.idOperacion,
                              'flagActivo': '0',
                              'usuario': this.$session.get('user')
                            }
                          ).then(response => {
                            this.error6 = response.data
                            this.carga();
                          })
                            .catch(error6 => {
                              if (error6.response && error6.response.status === 401) {
                                App.methods.logout.call(this);
                              }
                            })
                        })
                      })
                        .catch(error7 => {
                          if (error7.response && error7.response.status === 401) {
                            App.methods.logout.call(this);
                          }
                        })
                    } else {
                      this.carga();
                    }
                  })
                    .catch(error5 => {
                      if (error5.response.status === 401) {
                        App.methods.logout.call(this);
                      }
                    })
                });
              }
            })
              .catch(error => {
                if (error.response.status === 401) {
                  App.methods.logout.call(this);
                }
              })
          }


          //// Se realiza solo si se ha seleccionado un Rol en el combobox del modalNuevo
          if (this.ope.idRol !== '0' && this.ope.idOperacion == '0' || this.ope.idRol !== 0 && this.ope.idOperacion !== '0') {
            //////Obtener el ultimo idOperación creado con el axios anterior, para enviarlo al siguiente axios, esto con this.lastIdOpe.idOperacion        
            axios.get(
              `${apiURL}/operaciones/lastIdOpe/` + this.ope.descripcion
            ).then(response => {
              this.lastIdOpe = response.data[0]
              //console.log('lastIdOpe -----', this.lastIdOpe.idOperacion);

              axios.post(
                //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/opeByRol/add',
                `${apiURL}/operaciones/opeByRol/add`,
                {
                  'idOpeXRol': this.ope.idOpeXRol,
                  'idRol': this.ope.idRol,
                  /// En Agregar Nuevo (idOperacion = '0') usar lasIdOpe.idOperacion, mientras que en Editar usar ope.idOperacion 
                  'idOperacion': this.ope.idOperacion !== '0' ? this.ope.idOperacion : this.lastIdOpe.idOperacion,
                  'flagActivo': this.ope.flagActivo,  //// Para agregar, modificar  y anular
                  'usuario': this.$session.get('user')
                }
              ).then(response => {
                this.error4 = response.data
                ///Volver a cargar Operaciones, si ope.idOperacion es 0, cuando se Agrega Nueva Operación se carga toda la tabla
                this.carga();
              })
                .catch(error4 => {
                  if (error4.response && error4.response.status === 401) {
                    App.methods.logout.call(this);
                  }
                })
            })
              .catch(error => {
                if (error.response && error.response.status === 401) {
                  App.methods.logout.call(this);
                }
              })
          } else {
            ///Volver a cargar Operaciones, si ope.idOperacion es 0, cuando se Agrega Nueva Operación se carga toda la tabla
            this.carga();
          }
        })
          .catch(error => {
            if (error.respomse && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },        
    ver: function (ope) {
      this.cargarRoles(this.idAppFil);
      this.cargaOpeSup(this.idAppFil);
      this.texto = 'ACTUALIZAR LOS DATOS DE LA OPERACIÓN'
      //this.ope = ope
      this.ope = { ...ope };
      this.error.desError = ''
    },
    verAnular: function (ope) {
      this.ope = { ...ope }
      this.ope.flagActivo = '0'
      this.error.desError = ''
    },
    limpiar: function () {
      this.error.desError = ''
      this.cargarRoles(this.idAppFil);

      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/*/' + this.idAppFil + '/0'
        `${apiURL}/operaciones/*/` + this.idAppFil + '/0'
      ).then(response => {
        this.opes = response.data
        $('#tablaDetalle').dataTable().fnDestroy()
        this.$nextTick(() => {
          $('#tablaDetalle').DataTable({
            stateSave: true,
            'oLanguage': {
              'sSearch': 'Buscar',
              'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
              'sEmptyTable': 'Sin Data',
              'ZeroRecords': 'No se encontraron coincidencias',
              'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
              'sLengthMenu': '_MENU_ Registros por pagina',
              'oPaginate': {
                'sPrevious': 'Anterior',
                'sNext': 'Siguiente'
              }
            }
          })
        })
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/*/' + this.idAppFil + '/1'
        `${apiURL}/operaciones/*/` + this.idAppFil + '/1'
      ).then(response => {
        this.cbOpes = response.data
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      this.texto = 'REGISTRAR UNA NUEVA OPERACIÓN'
      this.ope.idOperacion = '0'
      this.ope.descripcion = ''
      this.ope.idApp = this.idAppFil
      this.ope.flagPrincipal = '0'
      this.ope.enlaceWeb = ''
      this.ope.idOpeSup = '0'
      this.ope.flagSeccion = 'I'
      this.ope.idRol = '0'
      this.ope.icono = ''
      this.ope.titulo_adic = ''
      this.ope.icono_adic = ''
      this.ope.descripcion_adic = ''
      this.ope.flagActivo = '1'
    },
    cargaOpeSup: function (vidApp) {
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/*/' + vidApp + '/1'
        `${apiURL}/operaciones/*/` + vidApp + '/1'
      ).then(response => {
        this.cbOpes = response.data
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    cargarRoles: function (vidApp) {
      axios.get(`${apiURL}/operaciones/rolByApp/` + vidApp)
        .then(response => {
          this.rols = response.data;
          //console.log('--Roles obtenidos:', this.rols);
        })
        .catch(error => {
          console.error('Error al obtener los roles:', error);
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          } else if (error.response && error.response.status === 404) {            
            App.methods.logout.call(this);
          }
        });
    },
    /// resetear el combobox de Roles en el modalNuevo
    resetSelection() {
      this.ope.idRol = '0';
    },
    /// resetear el combobox de OpeSup en el modal Nuevo
    resetSelection2() {
      this.ope.idOpeSup = '0';
    },
    alertaError() {
      Swal.fire({
        icon: 'error',
        title: 'Usuario No Autorizado',
        text: 'No tienes permisos para acceder.',
        timer: 2000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        this.$router.go(-1);
      });
    },
    alertaError401() {
      Swal.fire({
        icon: 'error',
        title: 'La sesión ha expirado',
        //text: 'Vuelve a iniciar sesión.',
        footer: '<a href="#">Vuelve a iniciar sesión.</a>',
        timer: 3000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        //this.$session.destroy()
        //this.$router.push('/login')
        App.methods.logout.call(this); ///Cierra la sesión 
      });
    },
    alertaError500() {
      Swal.fire({
        icon: 'error',
        title: 'Error interno del servidor',
        text: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde..',
        timer: 5000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        this.$router.go(-1);
      });
    },
    ///del v-select de  Aplicaciones
    selectApp() {
      if (this.selectedIdApp && this.selectedIdApp.idApp) {
        //console.log('Ejecutando selectApp', this.selectedIdApp);
        this.idAppFil = this.selectedIdApp.idApp
        this.limpiar()
        this.error.desError = ''
      } else {
        //console.warn('selectedIdArea es null o no tiene id');    
        this.opes = []
        this.cbOpes = []
        this.rols = []
        // Destruir la instancia DataTable si ya existe
        const dataTableInstance = $('#tablaDetalle').DataTable();
        if (dataTableInstance) {
          dataTableInstance.destroy();
        }
        this.error.desError = ''
      }
    },

  },
  computed: {
    /// del v-select de Aplicaciones
    filteredApps() {
      const lowerSearchText = this.searchText.toLowerCase();
      return this.apps.map(app => {
        if (app && app.descripcion) {
          return {
            ...app,
            nombreApp: `${app.descripcion}`
          };
        }
        return null;
      }).filter(app => app && (
        app.descripcion.toLowerCase().includes(lowerSearchText)
      ));
    },
  }
}

</script>

<style>
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

.custom-cursor {
  cursor: pointer;
}

.combobox-personalizado4 {
  margin-left: 0px;
  min-width: 800px;
  width: 800px;
  font-size: 17px;
  /* font-weight: bold;*/
  font-family: "Arial";
  color: black;
}

@media (max-width: 767px) {
  .combobox-personalizado4 {
    min-width: 350px;
    max-width: none; 
    font-size: 14px;
  }
}

.combobox-personalizado5 {
  margin-left: 0px;
  min-width: 570px;
  width: 570px;
  font-size: 13px;
  /* font-weight: bold;*/
  font-family: "Arial";
  color: black;
}

@media (max-width: 767px) {
  .combobox-personalizado5 {
    min-width: 350px;
    max-width: none; 
    font-size: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// Operaciones.vue?021925c2